import { UNIFIED_MENU, userHasCompanyRole } from '../../../config/subscriptionConfig';

const ADMIN_ROLES = ['admin', 'adminves', 'superuser'];

/**
 * Can this user open the screen `screenId` (an id from UNIFIED_MENU's submenus)?
 *
 * The same answer the app gives elsewhere, so the board does not offer a way into a screen
 * the route guard (PrivateRoute) would turn them away from:
 * - no company role → the admin roles see everything, nobody else does (a role that names
 *   no screens is a role: it opens none);
 * - the role must list the screen's category;
 * - a role that lists the category and none of its screens predates the screen ids and so
 *   sees all of them (as the sidebar does); otherwise the screen itself must be listed.
 * No user at all is an unknown answer, and an unknown answer never hides anything here.
 */
export const canOpenScreen = (user, screenId) => {
  if (!user) return true;
  const menu = Array.isArray(user.menuPermissions) ? user.menuPermissions : [];
  if (!userHasCompanyRole(user)) return ADMIN_ROLES.includes(user.role);
  const category = UNIFIED_MENU.find((item) => (item.submenu || []).some((sub) => sub.id === screenId));
  if (!category) return menu.includes(screenId);
  if (!menu.includes(category.id)) return false;
  const screens = category.submenu.map((sub) => sub.id);
  if (!screens.some((id) => menu.includes(id))) return true;
  return menu.includes(screenId);
};
